module.exports = __webpack_public_path__ + "img/productPage1.34666c4c.png";